import axios from '../axios';

export function encyclopediaEntryType(params) {
  return axios.get('hs_encyclopedia/1.0/encyclopedia_entry_type', params);
}

// 专题下的课程列表
export function encyclopediaCoursePage(params) {
  return axios.get('hs_encyclopedia/1.0/encyclopedia_course_page', params);
}

// 课程详情
export function knowledgeList(params) {
  return axios.get('hs_encyclopedia/1.0/knowledge_list', params);
}

// 课节详情
export function chapterList(params) {
  return axios.get('hs_encyclopedia/1.0/chapter_list', params);
}
